/**
 * Toast helpers. Use `toast` (re-exported from sonner) for success and info,
 * and `toastApiError` for failures so every error toast has the same shape:
 * title, detail, and a request ID people can quote to support.
 */
import { toast } from 'sonner'
import { asApiError } from '@/api/errors'

export { toast }

export function toastApiError(error: unknown, fallbackTitle?: string): void {
  const e = asApiError(error)
  const lines = [e.detail, e.requestId ? `Request ID ${e.requestId}` : undefined].filter(Boolean)
  const firstField = e.errors[0]
  if (!e.detail && firstField)
    lines.unshift(
      firstField.path ? `${firstField.path}: ${firstField.message}` : firstField.message,
    )
  toast.error(fallbackTitle && e.status <= 0 ? fallbackTitle : e.title, {
    id: e.isNetworkError ? 'network-error' : undefined,
    description: lines.join('\n') || undefined,
  })
}
